import api from "../api/api";
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const aparelhoService = {




  obterTodos: async (params) => {
    try {
      console.log('estoua qui service do aparelho');
      const url = `${BASE_URL}/aparelhos-localizacao-geral`;
      const response = await api.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao obter maquinas:", error);
      throw new Error("Erro ao obter maquinas.");
    }
  },




    // Buscar tipo específico COM fotos
    obterTipoComFotos: async (id) => {
      try {
        console.log(`📷 Buscando tipo de aparelho com fotos ID: ${id}`);
        const url = `${BASE_URL}/tipo-aparelhos/${id}/with-photos`;
        const response = await api.get(url);
        return response.data;
      } catch (error) {
        console.error("❌ Erro ao obter tipo com fotos:", error);
        throw new Error("Erro ao obter tipo de aparelho com fotos.");
      }
    },

    
  obterPorId: async (id) => {
    try {
      const url = `${BASE_URL}/aparelhos-maquinas/${id}/ficha-completa`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error("Erro ao obter maquina por id:", error);
      throw new Error("Erro ao obter maquina por id.");
    }
  }

  // ... Outros métodos, como criar, atualizar, deletar, etc., também devem seguir essa estrutura.
};
